import type { FieldValues, UseFormReturn } from 'react-hook-form';
import type { SaveProgressButtonProps } from '@/components/navigation/save-progress-button';
import { useVisitNavigation } from '@/contexts/visit-navigation-context';

export function useSaveProgressProps<T extends FieldValues>(
  form: UseFormReturn<T>,
  onSubmit: (data: T, isIncomplete: boolean) => void | Promise<void>,
): SaveProgressButtonProps {
  const { editMode } = useVisitNavigation();

  return {
    showModal: !form.formState.isValid || (!!editMode && form.formState.isDirty),
    onSaveClick: form.handleSubmit((data) => onSubmit(data, true)),
  };
}
